import { render, staticRenderFns } from "./LeitorPdf.vue?vue&type=template&id=23af9f90&scoped=true"
import script from "./LeitorPdf.vue?vue&type=script&lang=js"
export * from "./LeitorPdf.vue?vue&type=script&lang=js"
import style0 from "./LeitorPdf.vue?vue&type=style&index=0&id=23af9f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23af9f90",
  null
  
)

export default component.exports